import { render, staticRenderFns } from "./SalerOverview.vue?vue&type=template&id=564e9ffe"
import script from "./SalerOverview.vue?vue&type=script&lang=js"
export * from "./SalerOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports